import { render, staticRenderFns } from "@/components/Layout/Comentarios/Comentarios.html?vue&type=template&id=17935de8&scoped=true&"
import script from "@/components/Layout/Comentarios/Comentarios.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Comentarios/Comentarios.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Comentarios/Comentarios.css?vue&type=style&index=0&id=17935de8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17935de8",
  null
  
)

export default component.exports